/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react";
import { toast } from "react-toastify";
import { useGuardarMaestraMutation, useEditarMaestraMutation, useActivarInactivarMaestraMutation } from "src/redux/api/maestrosApi";
import { MaestrosResponse, EditarMaestroRequest } from "src/redux/api/types/maestros";
import { ImotivoInavacionForm } from "src/components/dialogo/utils";
import { EuiBasicTableColumn} from "@elastic/eui";
import useValidarRol from "src/hooks/useValidateRol";
import { useNavigate } from "react-router-dom";
import { useActualizarEstadoAspiranteMutation, useAsignarGestorMutation, useGuardarVerificacionesMutation, useObtenerAspirantesQuery } from "src/redux/api/aspirantesApi";
import { Typography } from "@mui/material";
import { IitemAspiranteResponse, IobtenerAspirantesRequest } from "src/redux/api/types/aspirantes";
import { IverificacionesForm } from "src/pages/gestion/aspirantes/detalle-aspitante/utils";
import { decodificarEstadoAspirante } from "src/utils/constantes";
import { Roles } from "src/utils/roles/roles";
import { ImaestroForm } from "./utils";
import { IfiltrosForm } from "./filtros/utils";
import { IAsignarGestorForm } from "./asignar-gestor/utils";
import { useLazyObtenerArchivoConsolidadoQuery } from "src/redux/api/documentosSoporteApi";
import { formatearFecha } from '../../../../utils/fechas';

export const useAspirantes = (unidadId: string | undefined, tipoMaestra: string) => {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [sortField, setSortField] = useState<string | number | symbol>("aspiranteId");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [valorBusqueda, setValorBusqueda] = useState<string>("");

  const { validarRolActivoEstaEntreLosRoles, usuarioId } = useValidarRol();
  const [request, setRequest] = useState<IobtenerAspirantesRequest>();
  const { data: aspirantesResp, isLoading: cargandoAspirantes, isFetching: refrescandoAspirantes, refetch } = useObtenerAspirantesQuery({ 
    ...request, 
    paginador: { page:pageIndex, size:pageSize, sort: ['fechaCreacion', 'desc'] },
    usuarioAsignadoId: validarRolActivoEstaEntreLosRoles([Roles.GESTOR]) ? usuarioId: request?.usuarioAsignadoId
  });

  const [abrirCrearEditarMaestroDialog, setAbrirCrearEditarMaestroDialog] = useState(false);
  const [maestroAintervenir, setMaestroAintervenir] = useState<MaestrosResponse | undefined>(undefined);
  const [aspiranteAintervenir, setAspiranteAintervenir] = useState<IitemAspiranteResponse | undefined>(undefined);
  const [mostrarConfirmacionInactivar, setMostrarConfirmacionInactivar] = useState(false);
  const [mostrarConfirmacionReactivar, setMostrarConfirmacionReactivar] = useState(false);
  const [mostrarConfirmacionContratacion, setMostrarConfirmacionContratacion] = useState(false);
  const [mostrarMotivoInactivacion, setMostrarMotivoInactivacion] = useState(false);
  const [mostrarAsignacionUsuario, setMostrarAsignacionUsuario] = useState(false);
  const [mostrarDetalleAspirante, setMostrarDetalleAspirante] = useState(false);

  const [guardarMaestra, { isLoading: guardandoMaestra }] = useGuardarMaestraMutation();
  const [editarMaestra, { isLoading: editandoMaestra }] = useEditarMaestraMutation();
  const [activarInactivarMaestro, { isLoading: activandoInactivandoMaestro }] = useActivarInactivarMaestraMutation();
  const [asignarUsuarioGestor, { isLoading: asignadoGestor }] = useAsignarGestorMutation();
  const [actualizarEstado] =useActualizarEstadoAspiranteMutation();

  const [guardarVerificaciones] = useGuardarVerificacionesMutation();

  const [obtenerAdjunto] =
      useLazyObtenerArchivoConsolidadoQuery();


  const handleConfirmacionInactivar = (maestro: MaestrosResponse) => {
    setMaestroAintervenir(maestro);
    setMostrarConfirmacionInactivar(true);
  };

  const handleConfirmacionReactivar = (maestro: MaestrosResponse) => {
    setMaestroAintervenir(maestro);
    setMostrarConfirmacionReactivar(true);
  };

  const handleMotivoInactivacion = (maestro: MaestrosResponse) => {
    setMaestroAintervenir(maestro);
    setMostrarMotivoInactivacion(true);
  };

  const handleFiltrarProyectos = (filtros: IfiltrosForm) => {
    setRequest({
      estado: filtros.estado,
      perfil: filtros.perfil,
      usuarioAsignadoId: filtros.usuarioAsignadoId,
      nombres: filtros.nombres,
      apellidos: filtros.apellidos,
      identificacion: filtros.identificacion,
    })
    setPageIndex(0);
  };

  const handleCrearEditarMaestro = (valores: ImaestroForm) => {
    if (valores.tipoMaestraId) {
      editarMaestra(valores as EditarMaestroRequest).unwrap().then(() => {
        toast.success("Maestro editado exitosamente");
        setAbrirCrearEditarMaestroDialog(false);
      });
    } else {
      guardarMaestra(valores).unwrap().then(() => {
        toast.success("Maestro guardado exitosamente");
        setAbrirCrearEditarMaestroDialog(false);
      });
    }
    setMaestroAintervenir(undefined);
  };

  const handleInactivarMaestro = (valores: ImotivoInavacionForm) => {
    activarInactivarMaestro({ tipoMaestraId: valores.elementoId, razon: valores.motivoInactivacion }).unwrap().then(() => {
      toast.success("Maestro inactivado exitosamente");
      setMostrarConfirmacionInactivar(false);
    });
    setMaestroAintervenir(undefined);
  };

  const handleAsignarUsuarioGestor = (valores: IAsignarGestorForm) => {
    asignarUsuarioGestor({ usuarioId: valores.usuarioAsignadoId, aspiranteId: aspiranteAintervenir?.aspiranteId || '' }).unwrap().then(() => {
      toast.success("Gestor asignado exitosamente");
      setMostrarAsignacionUsuario(false);
      setAspiranteAintervenir(undefined);
      refetch();
    });
  };

  const handleGuardarVerificacion = (values: IverificacionesForm) => {
    
    guardarVerificaciones({verificaciones: [...Object.values(values)]}).unwrap().then(
      () => {
        toast.success("Revisión guardada exitosamente");
      }
    )
  }

  const handleReactivarMaestro = (maestro: MaestrosResponse) => {
    activarInactivarMaestro({ tipoMaestraId: maestro.tipoId, razon: 'Reactivación' }).unwrap().then(() => {
      toast.success("Maestro reactivado exitosamente");
      setMostrarConfirmacionReactivar(false);
    });
    setMaestroAintervenir(undefined);
  };

  const navigate = useNavigate();
  const verUnidadAcademica = (proyecto: IitemAspiranteResponse) => {
    // const breadcrumb = { label: unidad.nombre || "", url: "/" };
    // dispatch(addBreadcrumb(breadcrumb));
    navigate(`/gestion/proyectos/${proyecto.aspiranteId}`);
  };

  const asignarGestor = (aspirante: IitemAspiranteResponse) => {
    setAspiranteAintervenir(aspirante);
    setMostrarAsignacionUsuario(true);
  };

  const marcarComoContratado = (aspirante: IitemAspiranteResponse) => {
    setAspiranteAintervenir(aspirante);
    setMostrarConfirmacionContratacion(true);
  };

  const verDetalleAspirante = (aspirante: IitemAspiranteResponse) => {
    setAspiranteAintervenir(aspirante);
    setMostrarDetalleAspirante(true);
  };

  const descargarPdfConsolidado = (aspirante: IitemAspiranteResponse) => {
    obtenerAdjunto({ aspiranteId: aspirante.aspiranteId })
        .unwrap()
        .then((data) => {
          const url = window.URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${aspirante.nombres} ${aspirante.apellidos} - Consolidado.pdf`);
          document.body.appendChild(link);
          link.click();
          link.parentNode?.removeChild(link);
          window.URL.revokeObjectURL(url);
        });
  }

  const handleMarcarComoContratado = () => {
    actualizarEstado({ aspiranteId: aspiranteAintervenir?.aspiranteId ?? '', estado: 'CONTRATADO' }).unwrap().then(() => {
      toast.success("Aspirante marcado como contratado");
      setMostrarConfirmacionContratacion(false);
      refetch();
    }
    );
  }

  const columnasAspirantes: Array<EuiBasicTableColumn<IitemAspiranteResponse>> = [
    {
      name: 'Fecha',
      truncateText: true,
      render: (persona: IitemAspiranteResponse) => (
        <Typography variant="body2" textAlign="left">
          {formatearFecha(persona.fechaCreacion)}
        </Typography>
      ),
      mobileOptions: {
        show: false,
      },
      width: '150px'
    },
    {
      name: "Aspirante",
      truncateText: false,
      render: (persona: IitemAspiranteResponse) => (
        <Typography variant="body2" textAlign="left">
         {persona.identificacion} - {persona.nombres} {persona.apellidos}
        </Typography>
      ),
      mobileOptions: {
        header: false,
        truncateText: false,
        enlarge: true,
        width: "100%",
      },
      width: "300px",
    },
    {
      field: 'correo',
      name: 'Email',
      truncateText: true,
      mobileOptions: {
        show: false,
      },
      width: '100%'
    },
    {
      field: 'perfilNombre',
      name: 'Perfil',
      truncateText: true,
      mobileOptions: {
        show: false,
      },
      width: '130px'
    },
    {
      field: 'nombreUsuarioAsignado',
      name: 'Usuario asignado',
      width: '100%',
    },
    {
      field: "estado",
      name: "Estado",
      align: 'left',
      width: "100%",
      render: (estado: IitemAspiranteResponse["estado"]) => {
        return <Typography textAlign="left">{decodificarEstadoAspirante(estado)}</Typography>
      },
    },
    {
      name: 'Radicado',
      width: '100px',
      render: (aspirante: IitemAspiranteResponse) => {
        return aspirante.numeroRadicado &&<Typography textAlign="left">{aspirante.numeroRadicado} <br/> ({aspirante.fechaRadicado})</Typography>
      },
    },
    {
      name: '',
      width: '80px',
      actions: [
        {
          name: 'Detalle',
          description: 'Detalle del aspirante',
          type: 'icon',
          icon: 'inspect',
          onClick: verDetalleAspirante,
        },
        {
          name: 'Asignar gestor',
          description: 'Asignar gestor',
          type: 'icon',
          icon: 'user',
          available(item) {
            return (
              validarRolActivoEstaEntreLosRoles([Roles.ADMIN])
            );
          },
          onClick: asignarGestor,
        },
        {
          name: 'Marcar como contratado',
          description: 'Marcar como contratado',
          type: 'icon',
          icon: 'accessibility',
          available(item) {
            return (
              validarRolActivoEstaEntreLosRoles([Roles.ADMIN])
            );
          },
          onClick: marcarComoContratado,
        },
        {
          name: 'Pdf Consolidado',
          description: 'Consolidado Pdf',
          type: 'icon',
          icon: 'document',
          onClick: descargarPdfConsolidado,
        },
      ],
    },
  ];


  return {
    aspirantesResp,
    cargandoAspirantes,
    refrescandoAspirantes,
    pageIndex,
    pageSize,
    sortField,
    sortDirection,
    valorBusqueda,
    setValorBusqueda,
    setPageIndex,
    setPageSize,
    setSortField,
    setSortDirection,
    abrirCrearEditarMaestroDialog,
    setAbrirCrearEditarMaestroDialog,
    maestroAintervenir,
    setMaestroAintervenir,
    mostrarConfirmacionInactivar,
    setMostrarConfirmacionInactivar,
    mostrarConfirmacionReactivar,
    setMostrarConfirmacionReactivar,
    mostrarMotivoInactivacion,
    setMostrarMotivoInactivacion,
    mostrarConfirmacionContratacion,
    setMostrarConfirmacionContratacion,
    handleConfirmacionInactivar,
    handleConfirmacionReactivar,
    handleMotivoInactivacion,
    handleCrearEditarMaestro,
    handleInactivarMaestro,
    handleReactivarMaestro,
    guardandoMaestra,
    editandoMaestra,
    activandoInactivandoMaestro,
    columnasAspirantes,
    handleFiltrarProyectos,
    setAspiranteAintervenir,
    aspiranteAintervenir,
    setMostrarAsignacionUsuario,
    mostrarAsignacionUsuario,
    handleAsignarUsuarioGestor,
    mostrarDetalleAspirante,
    setMostrarDetalleAspirante,
    handleGuardarVerificacion,
    handleMarcarComoContratado
  };
};
